<template>
  <div id="pwd">
    <div class="title">修改密码</div>
    <ul v-if="isSonUser !== 'true'" class="from">
      <li class="item">
        <div class="key">原手机号</div>
        <div class="value">{{ userInfo.user.username | jiami }}</div>
      </li>
      <li class="item">
        <div class="key">手机验证码</div>
        <div class="value">
          <Input v-model="phoneKey" placeholder=""/>
          <input type="text" style="width: 0; opacity: 0;border: none;">
          <div @click="getCode()" :class="keyFlag ? 'getCode' : 'nullCode'">
            {{ keyButton }}
          </div>
        </div>
      </li>
      <li class="item">
        <div class="key">设置新密码</div>
        <div class="value">
          <Input
            v-model="setPwd"
            class="no-autofill-pwd"
          />
          <input type="text" style="width: 0; opacity: 0;border: none;">
        </div>
      </li>
      <li class="item">
        <div class="key">确认新密码</div>
        <div class="value">
          <Input
            v-model="setPwd2"
            class="no-autofill-pwd"
          />
          <input type="text" style="width: 0; opacity: 0;border: none;">
        </div>
      </li>
    </ul>
    <ul v-else class="from">
      <li class="item">
        <div class="key">输入旧密码</div>
        <div class="value">
          <Input
            v-model="sonFrom.upPwd"
            type="text"
            :icon="upPwdShowEye ? 'ios-eye-outline' : 'ios-eye-off-outline'"
            :class="upPwdShowEye ? '' : 'no-autofill-pwd'"
            @on-click="iconClick('upPwdShowEye')"
          />
        </div>
      </li>
      <li class="item">
        <div class="key">输入新密码</div>
        <div class="value">
          <Input
            v-model="sonFrom.newPwd"
            type="text"
            :icon="newPwdShowEye ? 'ios-eye-outline' : 'ios-eye-off-outline'"
            :class="newPwdShowEye ? '' : 'no-autofill-pwd'"
            @on-click="iconClick('newPwdShowEye')"
          />
        </div>
      </li>
      <li class="item">
        <div class="key">再次输入新密码</div>
        <div class="value">
          <Input
            v-model="sonFrom.newPwd2"
            type="text"
            :icon="newPwd2ShowEye ? 'ios-eye-outline' : 'ios-eye-off-outline'"
            :class="newPwd2ShowEye ? '' : 'no-autofill-pwd'"
            @on-click="iconClick('newPwd2ShowEye')"
          />
        </div>
      </li>
    </ul>
    <div class="btn">
      <div @click="closeAlert" class="close">取消</div>
      <Button v-throttleClick @click="affirmAlert" class="affirm">确认</Button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "pwd",
  filters: {
    jiami(val) {
      let reg = /(\d{3})\d{4}(\d{4})/; //正则表达式
      return val.replace(reg, "$1****$2");
    },
  },
  computed: {
    isSonUser() {
      return sessionStorage.getItem("isSon");
    },
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      phoneKey: "",
      setPwd: "",
      setPwd2: "",
      keyButton: "获取手机验证码",
      keyFlag: true,
      timer: null,
      upPwdShowEye: false,
      newPwdShowEye: false,
      newPwd2ShowEye: false,
      sonFrom: {
        upPwd: "",
        newPwd: "",
        newPwd2: "",
      },
    };
  },
  methods: {
    iconClick(name) {
      this[name] = !this[name];
    },
    closeAlert() {
      this.$emit("setAlert");
    },
    async affirmAlert() {
      const pasRegex = /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/
      if (sessionStorage.getItem("isSon") !== "true") {
        if( this.phoneKey === "" ) {
          this.$Message.error("请输入验证码");
          return;
        }
        if (isNaN(+this.phoneKey)) {
          this.$Message.warning('请输入正确的验证码');
          return          
        }
        if(this.setPwd === "" || this.setPwd2 === "" ) {
          this.$Message.error("请输入新密码");
          return;
        }
        if(!pasRegex.test(this.setPwd)){
          this.$Message.error('密码由数字、字符和符号至少两种组成，且6-16个字符之间！')
          return
        }
        if (this.setPwd !== this.setPwd2) {
          this.$Message.error("两次密码不一致");
          return;
        }
        let obj = {
          pwd: this.setPwd,
          validateCode: this.phoneKey,
        };
        const res = await this.$apis.userServe.setPwd(obj);
        if (res.resultCode == 200) {
          this.$Message.success(res.resultDesc);
          this.$emit("setAlert");
        } else {
          this.$Message.error(res.resultDesc);
        }
      } else {
        if( this.sonFrom.oldPwd === "" ) {
          this.$Message.error("请输入旧密码");
          return;
        }
        if( this.sonFrom.newPwd === "" || this.newPwd2 === "" ) {
          this.$Message.error("请输入密码");
          return;
        }
        if(!pasRegex.test(this.sonFrom.newPwd)){
          this.$Message.error('密码由数字、字符和符号至少两种组成，且6-16个字符之间！')
          return
        }
        if (this.sonFrom.newPwd !== this.sonFrom.newPwd2) {
          this.$Message.error("两次密码不一致");
          return;
        }
        let obj = {
          oldPwd: this.sonFrom.upPwd,
          pwd: this.sonFrom.newPwd2,
        };
        const res = await this.$apis.userServe.setSonPwd(obj);
        if (res.resultCode == 200) {
          this.$Message.success(res.resultDesc);
        } else {
          this.$Message.error(res.resultDesc);
        }
        this.$emit("setAlert");
      }
    },
    destroy() {
      clearInterval(this.timer);
      this.keyFlag = true;
      this.keyButton = "获取验证码";
    },
    getCode() {
      if (!this.keyFlag) return;
      this.keyFlag = !this.keyFlag;
      let num = 60;
      this.sendCode();
      this.keyButton = `${num}秒后重新获取`;
      this.timer = setInterval(() => {
        if (num <= 0) {
          this.destroy();
        } else {
          this.keyButton = `${--num}秒后重新获取`;
        }
      }, 1000);
    },
    sendCode() {
      let obj = {
        phone: this.userInfo.user.username,
        adapter: "reset_pwd",
      };
      this.$apis.loginServe.getCode(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
#pwd {
  padding: 38px 50px 0 40px;
  .btn {
    margin-top: 34px;
    width: 100%;
    height: 50px;
    //background: pink;
    display: flex;
    justify-content: center;
    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }
    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }
  .from {
    margin-top: 30px;
    .item {
      margin-top: 10px;
      margin-bottom: 10px;
      //background: pink;
      height: 32px;
      //width: 600px;
      display: flex;
      .key {
        width: 98px;
        line-height: 32px;
        text-align: right;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .value {
        display: flex;
        flex: 1;
        line-height: 32px;
        margin-left: 20px;
        .getCode {
          margin-left: 20px;
          cursor: pointer;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #007fff;
        }
        &::v-deep .ivu-input-wrapper {
          flex: 1;
        }
        .nullCode {
          cursor: pointer;
          margin-left: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
        .no-autofill-pwd {
          ::v-deep .ivu-input-default {
            -webkit-text-security:disc!important;
          }
        }
      }
    }
  }
  .title {
    margin-left: 10px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
}
</style>
